// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"Paragraph_Paragraph__nov4E","Paragraph___right":"Paragraph_Paragraph___right__Iihuj","Paragraph___bold":"Paragraph_Paragraph___bold__476lS"};